import { baseApi } from './baseApi'

export interface IntermediaCallRecord {
  globalCallId: string
  callId: string
  start: string
  direction: 'inbound' | 'outbound' | 'internal'
  duration: number
  fromNumber: string
  fromName: string
  toNumber: string
  toName: string
  fromUserUniqueId: string | null
  toUserUniqueId: string | null
}

export interface CallHistoryResult {
  calls: IntermediaCallRecord[]
  totalCalls: number
}

export interface UserRecordingItem {
  callId: string
  recordingId: number
  fileName: string
  userId: string
}

export interface UserRecordingsResult {
  recordings: UserRecordingItem[]
}

export const intermediaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCallHistory: builder.query<
      CallHistoryResult,
      { phoneNumber: string; page: number; dateFrom?: string; dateTo?: string }
    >({
      query: ({ phoneNumber, page, dateFrom, dateTo }) => ({
        url: '/lab/intermedia/call-history',
        params: {
          phoneNumber,
          page,
          pageSize: 10,
          ...(dateFrom ? { dateFrom } : {}),
          ...(dateTo ? { dateTo } : {}),
        },
      }),
      providesTags: ['CallHistory'],
    }),

    getUserRecordings: builder.query<UserRecordingsResult, { userIds: string[]; callId: string }>({
      query: ({ userIds, callId }) => ({
        url: '/lab/intermedia/user-recordings',
        params: { userIds: userIds.join(','), callId },
      }),
    }),

    getRecording: builder.query<string, { userId: string; recordingId: number }>({
      queryFn: async ({ userId, recordingId }, _queryApi, _extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: '/lab/intermedia/recording/stream',
          params: { userId, recordingId },
          responseHandler: async (response) => {
            if (!response.ok) return null
            const blob = await response.blob()
            return URL.createObjectURL(blob)
          },
          cache: 'no-cache',
        })
        if (result.error) return { error: result.error }
        if (!result.data) return { error: { status: 'CUSTOM_ERROR' as const, error: 'Recording not found' } }
        return { data: result.data as string }
      },
    }),
  }),
})

export const { useGetCallHistoryQuery, useGetUserRecordingsQuery, useGetRecordingQuery } = intermediaApi
